import $ from 'jquery';
import gwrf from "../vendor/gwrf";
class Popup {
	constructor(element) {
		$(document).ready(() => this.load());
	}

	load() {
		if($('a[href="#chat"]').length) {
			$('a[href="#chat"]').attr('data-openpopup','chat');
		}
		if($('[data-openpopup]').length) {
			$('[data-openpopup]').on('click',this.openPopup);
			$(document).on('click','[data-closepopup]',this.closePopup);
		}
	}

	openPopup(e) {
		e.preventDefault();
		$('body').addClass('no-scroll');

		if($(this).data('openpopup') == 'chat') {
			$('.twz-element-chat__form--next').html('');
			if(!$('#gform_wrapper_2').length) {
				$.get(TWZ.ajaxurl +'?action=twz_get_form&form_id=2',function(response){
					$('.twz-element-chat__form--2').html(response);

					setTimeout(function(){
						$('.twz-element-chat__form--2 .gform_wrapper').addClass('forminprogress');
					},100)
				});
			} else {
				$('#gform_wrapper_2 .answered').show(0).removeClass('answered');
				console.log($('#gform_wrapper_2 input:checked'));
				$('#gform_wrapper_2 input:checked').prop('checked',false);
			}
		}

		var curPopup = $('.twz-element.active');
		curPopup.removeClass('active');
		$('[data-popup="'+$(this).data('openpopup')+'"]').addClass('active');
	}

	closePopup(e) {
		e.preventDefault();
		$('body').removeClass('no-scroll');
		$('[data-popup="'+$(this).data('closepopup')+'"]').removeClass('active');
	}
}

new Popup